import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { appContext } from "../../context/ContextProvider";
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { useQuery, gql, useMutation } from "@apollo/client";
import { Form, Field, Formik } from "formik";

import usersGQL from "../../gql/users";
// import "react-toastify/dist/ReactToastify.css";
import AppLoader from "../../components/AppModal";
import AppModal from "../../components/AppModal";
import { Button, InputAdornment, TextField } from "@mui/material";
import LoginForm from "./LoginForm";
import { useTranslation } from "react-i18next";

//parse Permissions
export const parsePermissions = (data) => {
  let tempData = [];
  data.map((item, index) => {
    tempData.push(item.PermissionUrl);
  });

  return tempData;
};

function Login(props) {
  const { t, i18n } = useTranslation();
  const { user, setUser, setToken, setPermissions } = useContext(appContext);

  const [showLoader, setShowLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loginUser, { data, loading, error }] = useMutation(
    usersGQL.USER_LOGIN_MUTATION,
    {
      update(proxy, result) {
        setShowLoader(false);
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        setShowLoader(false);
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const onSuccessfulRequestResponse = (data) => {
    if (data?.userSignIn?.data?.jwt) {
      setToken(data.userSignIn.data.jwt);
      localStorage.setItem("token", JSON.stringify(data.userSignIn.data.jwt));

      setPermissions(parsePermissions(data.userSignIn.data.permission));
      localStorage.setItem(
        "permissions",
        JSON.stringify(parsePermissions(data.userSignIn.data.permission)),
      );

      let user = {
        FullName: data.userSignIn.data.full_name,
        Email: data.userSignIn.data.email,
        RoleId: data.userSignIn.data.role_id,
        RoleName: data.userSignIn.data.role_name,
      };
      setUser(user);
      localStorage.setItem("user", JSON.stringify(user));
    } else {
    }
  };

  const onResponseError = (error) => {
    toast.error(`Invalid Creds - ${error.message}`);
  };
  ///

  // const addData = values => {
  //   setShowLoader(true)
  //   let data = { input: { email: values.email, password: values.password } }
  //   loginUser({ variables: data })
  // }
  const initialValues = {
    email: "",
    password: "",
  };
  const handleSubmit = (values) => {
    setShowLoader(true);
    let data = { input: { email: values.email, password: values.password } };
    loginUser({ variables: data });
  };
  return (
    <>
      {/* <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validate={values => {
          const errors = {}
        }}
        onSubmit={(values, { setSubmitting }) => {
          addData(values)
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <div className='w-full'>
            <div className='w-full flex flex-row'>
              <div className='login-form h-screen w-full lg:w-1/2 flex justify-center items-center relative'>
                <div className='w-full lg:w-1/2 mx-4 lg:mx-0'>
                  <div className='mx-auto flex justify-center mb-4'>
                    <img
                      src='/images/supergit-01.png'
                      alt='logo'
                      className='w-32'
                    />
                  </div>
                  <h2 className='my-2 text-center text-2xl font-semibold leading-9 tracking-tight text-gray-900'>
                    Sign-in To NPHIES Connect
                  </h2>

                  <div className='w-full'>
                    <div className='bg-white px-1 py-1 sm:rounded-lg sm:px-1'>
                      <Form className='space-y-6'>
                        <div>
                          <div className='mt-2 relative'>
                            <PersonOutlineIcon className='absolute left-3 top-1/2 transform -translate-y-1/2 !text-orange-400' />
                            <Field
                              id='email'
                              name='email'
                              type='email'
                              autoComplete='email'
                              onChange={handleChange}
                              required
                              placeHolder='Email'
                              className='pl-12 block w-full border-slate-300 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6'
                              style={{
                                boxShadow:
                                  'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
                              }}
                            />
                          </div>
                        </div>

                        <div>
                          <div className='relative'>
                            <HttpsOutlinedIcon className='absolute left-3 top-1/2 transform -translate-y-1/2 !text-orange-400' />
                            <Field
                              id='password'
                              name='password'
                              type='password'
                              autoComplete='current-password'
                              onChange={handleChange}
                              required
                              placeHolder='Password'
                              className='pl-12 block w-full border-slate-300 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6'
                              style={{
                                boxShadow:
                                  'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
                              }}
                            />
                          </div>
                        </div>

                        <div>
                          <Button
                            variant='contained'
                            type='submit'
                            size='small'
                            style={{
                              backgroundImage:
                                'linear-gradient(83deg, #0070C2)',
                              boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
                            }}
                            disabled={showLoader}
                            className='flex w-full justify-center px-3 py-1.5 text-sm font-semibold leading-6 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 !normal-case'
                          >
                            {showLoader ? 'Signing In...' : 'Sign In'}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className='absolute bottom-0 m-3'>
                  <p className='bg-gray-100 py-1.5 px-3 text-gray-600 text-xs font-semibold rounded-full '>
                    Super-Git (NPHIES) v2.1.5
                  </p>
                </div>
              </div>

              <div className={`login-img w-1/2 h-screen  hidden lg:block`}>
                <div className='relative'>
                  <img
                    src='/images/Rectangle64.png'
                    alt='bg'
                    className='w-[80%] h-[95vh]  z-0 top-[15px] right-[25px] absolute object-fill'
                  />
                  <div className=' absolute w-[80%] flex flex-row h-[95vh] right-[25px] top-[15px] !px-5 !py-3  5xl:!p-[2.5rem] gap-2 4xl:!gap-4'>
                    <div className='w-[55%]'>
                      <div className='bg-[#212121] rounded-2xl'>
                        <div className='p-3 3xl:!p-5 4xl:!p-7 5xl:!p-10'>
                          <h2 className='text-white font-medium text-[16px] xl:!text-[18px] 2xl:!text-[25px] 3xl!:text-[30px] 4xl:!text-[35px] 5xl:!text-[45px] mb-2 !leading-[25px] 2xl:!leading-[28px] 3xl:!leading-[28px] 4xl:!leading-[35px] 5xl:!leading-[50px]'>
                            Effortless Management for Clinics & Hospitals Starts
                            Here!
                          </h2>
                          <p className='text-white text-[14px] xl:!text-[16px] 2xl:!text-[20px] 3xl:!text-[22px] 4xl:!text-[25px] 5xl:!text-[30px]  font-normal !leading-[18px] 2xl:!leading-[24px] 3xl:!leading-[24px] 4xl:!leading-[30px] 5xl:!leading-[40px]'>
                            The Ultimate ERP Solution for Clinics & Hospitals –
                            Streamline, Manage, and Excel
                          </p>
                        </div>
                      </div>
                      <div
                        className={` rounded-2xl flex justify-between flex-col gap-2 z-10 mt-2 4xl:!mt-4 !p-2 2xl:!p-3 3xl:!p-4 4xl:!p-5 5xl:!p-7`}
                        style={{
                          backgroundImage: "url('/images/Rectangle175.png')",
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}
                      >
                        <div className='bg-white flex items-center justify-evenly p-2 min-h-[70px]  xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px]  5xl:min-h-[150px]  rounded-[70px]'>
                          <div className='w-[25%] flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/prescription-bottle-medical-solid 1.png'
                            />
                          </div>
                          <div className='text-center w-[75%]'>
                            <h1 className=' font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Pharmacist Portal
                            </h1>
                            <p className=' text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Manage inventory and prescriptions
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex items-center justify-evenly p-2 min-h-[70px]  xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px]  5xl:min-h-[150px]  rounded-[70px]'>
                          <div className='w-[25%] flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/file-invoice-solid 1.png'
                            />
                          </div>
                          <div className='text-center w-[75%]'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Accounts Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Simplify billing and invoicing
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex items-center justify-evenly p-2 min-h-[70px]  xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px]  5xl:min-h-[150px]  rounded-[70px]'>
                          <div className='w-[25%] flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/hr-manager.png'
                            />
                          </div>
                          <div className='text-center w-[75%]'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              HR Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Simplify staff management
                            </p>
                          </div>
                        </div>
                        <div className='bg-white   flex items-center justify-evenly p-2  min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className='w-[25%] flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/money-bill-solid 1.png'
                            />
                          </div>
                          <div className='text-center w-[75%]'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              RCM Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Optimize revenue cycle operations
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='w-[45%] pt-12 2xl:!pt-[4rem] 3xl:!pt-[4.5rem] 4xl:!pt-[5rem] 5xl:!pt-[7.5rem]'>
                      <div
                        className={` rounded-2xl flex justify-between flex-col gap-2 z-10 mt-2  !p-2 2xl:!p-3 3xl:!p-4 4xl:!p-5`}
                        style={{
                          backgroundImage: "url('/images/Rectangle175.png')",
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}
                      >
                        <div className='bg-white flex flex-col items-center justify-evenly p-2 min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 4xl:min-h-[130px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className=' flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/Vector.png'
                            />
                          </div>
                          <div className='text-center'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Doctor Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Manage Appointments and Records
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex items-center flex-col justify-evenly p-2 min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 4xl:min-h-[130px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className=' flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/Vector (1).png'
                            />
                          </div>
                          <div className='text-center '>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Nurse Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Coordinate care with ease
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex-col flex items-center justify-evenly p-2 min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 4xl:min-h-[130px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className='flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/Vector (2).png'
                            />
                          </div>
                          <div className='text-center w-[70%]'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Lab Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Track tests and results
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex flex-col items-center justify-evenly p-2 min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 4xl:min-h-[130px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className=' flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/Clip path group.png'
                            />
                          </div>
                          <div className='text-center'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Reception Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Streamline appointments effortlessly
                            </p>
                          </div>
                        </div>
                        <div className='bg-white flex flex-col items-center justify-evenly p-2  min-h-[70px] xl:min-h-[80px] 2xl:min-h-[105px] 3xl:min-h-[115px] 4xl:min-h-[130px] 5xl:min-h-[150px]  rounded-[70px]'>
                          <div className=' flex items-center justify-center'>
                            <img
                              className='!h-[26px] !w-[26px] xl:!h-[26px] xl:!w-[26px] 2xl:!h-[40px] 2xl:!w-[40px] 5xl:!h-auto 5xl:!w-auto'
                              src='/images/x-ray-solid 1.png'
                            />
                          </div>
                          <div className='text-center'>
                            <h1 className='  font-medium text-[16px] xl:text-[16px] 2xl:text-[20px] 3xl:!text-[22px] 4xl:!text-[26px] 5xl:!text-[34px] leading-[18px] 2xl:leading-[23px] 3xl:leading-[26px] 4xl:leading-[28px] 5xl:!leading-[35px]'>
                              Radiology Portal
                            </h1>
                            <p className='text-[15px] xl:text-[14px] 2xl:text-[17px] 3xl:!text-[18px] 4xl:!text-[22px] 5xl:!text-[30px] font-normal text-center leading-[14px] 2xl:leading-[16px] 3xl:leading-[18px] 4xl:leading-[20px] 5xl:!leading-[30px]'>
                              Streamline imaging and diagnostics
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik> */}
      <div className="grid grid-cols-1 lg:grid-cols-2 h-screen">
        {/* LEFT IMAGE */}
        <img
          className="hidden lg:block h-full w-full object-cover"
          src="/images/bannerSupergit.png"
        />

        {/* RIGHT LOGIN */}
        <div className="flex items-center justify-center relative px-6">
          <div
            className={`absolute top-4 ${
              i18n.language === "ar" ? "left-4" : "right-4"
            } flex items-center gap-3`}
          >
            <p className="bg-gradient-to-b from-[#0070C2] to-[#00A0E0] py-1 px-2 text-white text-[12px] font-medium rounded-full uppercase shadow-md">
              {t("SuperGit (NPHIES) v2.1.5")}
            </p>
          </div>
          <div className="w-full max-w-[500px]">
            <div className="flex flex-col items-center mb-6">
              <img src="/images/supergit-03.png" className="w-32" />
              <h2 className="text-2xl font-semibold mt-3 text-center">
                {t("Sign In To NPHIES")}
              </h2>
            </div>

            <LoginForm
              isLoading={showLoader}
              t={t}
              handleSubmit={handleSubmit}
              initialValues={initialValues}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
